var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "progress-group" }, [
    _c("div", { staticClass: "option option-1" }, [
      _c("span", { staticClass: "end" }, [_vm._t("term")], 2)
    ]),
    _c("div", { staticClass: "progress" }, [
      _c("div", { staticClass: "value", style: { width: _vm.percent + "%" } }, [
        _c("span", { staticClass: "ing" }, [_vm._t("ing")], 2)
      ]),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "progress-bar", style: { width: _vm.percent + "%" } },
        [_c("div", { staticClass: "bar" })]
      )
    ]),
    _c("div", { staticClass: "option option-2" }, [
      _c("div", { staticClass: "start" }, [_c("span", [_vm._t("start")], 2)]),
      _c("div", { staticClass: "end" }, [_c("span", [_vm._t("end")], 2)])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "division" }, [
      _c("span", { staticClass: "line" }),
      _c("span", { staticClass: "line" }),
      _c("span", { staticClass: "line" }),
      _c("span", { staticClass: "line" }),
      _c("span", { staticClass: "line" }),
      _c("span", { staticClass: "line" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }